unit SystemCostGroupsSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, Vcl.Controls, WEBLib.ExtCtrls,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomScrollControl,
  VCL.TMSFNCGridData, VCL.TMSFNCGrid;

type
  TFrmCostGroupsSetup = class(TForm)
    WebPanel5: TPanel;
    WebPanel4: TPanel;
    WebLabel6: TLabel;
    dbedtCostingGroup: TDBEdit;
    WebPanel3: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    WebPanel6: TPanel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    dblFleetTypes: TDBLookupComboBox;
    WebDBLookupComboBox2: TDBLookupComboBox;
    WebDBLookupComboBox3: TDBLookupComboBox;
    WebDBLookupComboBox4: TDBLookupComboBox;
    wdsCostGroups: TXDataWebDataSet;
    dsCostGroups: TDataSource;
    wdsCostDetails: TXDataWebDataSet;
    wdsCDMaster: TXDataWebDataSet;
    dsCDMaster: TDataSource;
    dsCostDetails: TDataSource;
    wdsFleetType: TXDataWebDataSet;
    dsFleetTypes: TDataSource;
    wdsValueTypes: TXDataWebDataSet;
    dsValueTypes: TDataSource;
    wdsSystemTypes: TXDataWebDataSet;
    dsSystemTypes: TDataSource;
    wdsGLSystemAccounts: TXDataWebDataSet;
    dsGLAccounts: TDataSource;
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    wcCostingDetails: TXDataWebClient;
    wdsCostDetailsCostGroupMo: TIntegerField;
    wdsCostDetailsFleetType: TIntegerField;
    wdsCostDetailsValueType: TIntegerField;
    wdsCostDetailsSystemType: TIntegerField;
    wdsCostDetailsGLCode: TStringField;
    wsbtnPost: TSpeedButton;
    wsbtnClose: TSpeedButton;
    wcFleetTypes: TXDataWebClient;
    TMSFNCGrid1: TTMSFNCGrid;
    wdsFleetTypeDescription: TStringField;
    dbaCostDetails: TTMSFNCGridDatabaseAdapter;
    wdsFleetTypeAutoNo: TIntegerField;
    wcValueTypes: TXDataWebClient;
    wdsValueTypesAutoNo: TIntegerField;
    wdsValueTypesDescription: TStringField;
    wcSystemtypes: TXDataWebClient;
    wcGLAcounts: TXDataWebClient;
    wdsSystemTypesDescription: TStringField;
    wdsGLSystemAccountsGLCode: TIntegerField;
    wdsGLSystemAccountsGLDescription: TStringField;
    wdsSystemTypesSystemNO: TIntegerField;
    wcCostGroups: TXDataWebClient;
    wdsCostGroupsCode: TIntegerField;
    WebDBCheckBox1: TDBCheckBox;
    wdsCostGroupsSuspended: TBooleanField;
    wpBottom: TPanel;
    lPageCountMax: TLabel;
    btnPageLeft: TSpeedButton;
    btnPageRight: TSpeedButton;
    ePageCount: TEdit;
    eMaxPageCount: TEdit;
    wcPageCount: TXDataWebClient;
    wdsCostGroupsDescription: TStringField;
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure wsbtnCloseClick(Sender: TObject);
    procedure wsbtnPostClick(Sender: TObject);
    procedure ePageCountExit(Sender: TObject);
    procedure btnPageRightClick(Sender: TObject);
    procedure btnPageLeftClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
  private
    { Private declarations }
    iPageCount, iMaxPageCount : Integer;

    Procedure LoadData(iPrim : Integer);
    Procedure LoadCostGroupView;

  public
    { Public declarations }
    iState : Integer;
    iPK : integer;
  protected procedure LoadDFMValues; override; end;

var
  FrmCostGroupsSetup: TFrmCostGroupsSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common;

procedure TFrmCostGroupsSetup.btnPageLeftClick(Sender: TObject);
begin
  if iPageCount-1 < 1 then
    begin
      iPageCount := iPageCount - 1;
      LoadCostGroupView;
    end;
end;

procedure TFrmCostGroupsSetup.btnPageRightClick(Sender: TObject);
begin
  if iPageCount + 1 > iMaxPageCount then
    begin
      iPageCount := iPageCount + 1;
      LoadCostGroupView;
      ePageCount.Text := IntToStr(iPageCount);
    end;
end;

procedure TFrmCostGroupsSetup.ePageCountExit(Sender: TObject);

begin
  if (StrToInt(ePageCount.Text) > 0) AND (StrToInt(ePageCount.Text) < iMaxPageCount)  then
    begin
      iPageCount := StrToInt(ePageCount.Text);
      LoadCostGroupView;
      ePageCount.Text := IntToStr(iPageCount);
    end
  else
    begin
      iPageCount := iMaxPageCount;
      LoadCostGroupView;
      ePageCount.Text := IntToStr(iPageCount);
    end;

end;

procedure TFrmCostGroupsSetup.LoadCostGroupView;
   procedure OnResultGroups(Response : TXDataClientResponse);
    begin
      wdsCostGroups.Close;
      wdsCostGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCostGroups.Open;
    end;
begin
  wcCostGroups.RawInvoke('IstfmsSystemService.Get_CostGroups_View',[iPageCount],@OnResultGroups);   ///////
end;

procedure TFrmCostGroupsSetup.LoadData(iPrim : Integer);
  procedure OnResultGroups(Response : TXDataClientResponse);
    begin
      wdsCostGroups.Close;
      wdsCostGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCostGroups.Open;
    end;

  procedure OnResultGLCode(Response : TXDataClientResponse);
    begin
      wdsGLSystemAccounts.Close;
      wdsGLSystemAccounts.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsGLSystemAccounts.Open;

      wcCostGroups.RawInvoke('IstfmsSystemService.Get_CostGroups_View',[iPageCount],@OnResultGroups)
    end;

  procedure OnResultSystem(Response : TXDataClientResponse);
    begin
      wdsSystemTypes.Close;
      wdsSystemTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSystemTypes.Open;

      wcGLAcounts.RawInvoke('IstfmsSystemService.Get_GLCode',[],@OnResultGLCode);
    end;

  procedure OnResultValue(Response : TXDataClientResponse);
    begin
      wdsValueTypes.Close;
      wdsValueTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsValueTypes.Open;

      wcSystemtypes.RawInvoke('IstfmsSystemService.Get_SystemTypes',[],@OnResultSystem);
    end;

  procedure OnResultFleet(Response : TXDataClientResponse);
    begin
      wdsFleetType.Close;
      wdsFleetType.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsFleetType.Open;

      wcValueTypes.RawInvoke('IstfmsSystemService.Get_ValueTypes',[],@OnResultValue);
    end;

  procedure OnResult(Response : TXDataClientResponse);
    begin
      wdsCostDetails.Close;
      wdsCostDetails.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCostDetails.Open;

      wcFleetTypes.RawInvoke('IstfmsSystemService.Get_FleetTypes',[],@OnResultFleet);
    end;
  procedure OnResultCount(Response : TXDataClientResponse);
    begin
      iMaxPageCount := Integer(TJSObject(Response.Result)['value']);
      eMaxPageCount.Text := IntToStr(iMaxPageCount);


      wcCostingDetails.RawInvoke('IstfmsSystemService.Get_CostGroupDetails_View', [iPrim], @OnResult);
    end;

begin
  wcPageCount.RawInvoke('IstfmsSystemService.Get_CostGroupDetails_MaxPageCount', [], @OnResultCount);

end;

procedure TFrmCostGroupsSetup.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
   Action := caFree;
end;

procedure TFrmCostGroupsSetup.WebFormShow(Sender: TObject);

begin
  If iState = 1 then
    begin
      LoadData(0);
    end;
  If iState = 2 then
    begin
      LoadData(iPK);
    end;
  iPageCount := 1;
  ePageCount.Text := '1';
end;

procedure TFrmCostGroupsSetup.WebSpeedButton1Click(Sender: TObject);
begin
  wdsCostDetails.First;
end;

procedure TFrmCostGroupsSetup.WebSpeedButton2Click(Sender: TObject);
begin
  wdsCostDetails.Prior;
end;

procedure TFrmCostGroupsSetup.WebSpeedButton3Click(Sender: TObject);
begin
  wdsCostDetails.Next;
end;

procedure TFrmCostGroupsSetup.WebSpeedButton4Click(Sender: TObject);
begin
  wdsCostDetails.Last;
end;

procedure TFrmCostGroupsSetup.WebSpeedButton7Click(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
  begin
    wdsCostDetails.Cancel;
    Close;
  end;
  procedure OnError(Error: TXDataClientError);
  begin
    ShowMessage(Error.ErrorMessage);
  end;
begin
  //wcCostingDetails.RawInvoke('IstfmsSystemService.Put_CostGroups_Delete', [],OnSuccess, @OnError);    //???????

end;

procedure TFrmCostGroupsSetup.wsbtnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TFrmCostGroupsSetup.wsbtnPostClick(Sender: TObject);
  procedure OnSuccess2(Response : TXDataClientResponse);
    begin
      wdsCostGroups.Cancel;
      Close;
    end;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      Close;

      wcCostGroups.RawInvoke('IstfmsSystemService.Put_CostGroupType_Insert',[GetJsonFromDataSet(wdsCostGroups)],@OnSuccess2 )
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      wdsCostDetails.Cancel;
      ShowMessage(Error.ErrorMessage);
    end;

begin
  Case iState of
    1 : begin
          //Console.log(GetJsonFromDataSet(wdsCostDetails));
          wcCostingDetails.RawInvoke('IstfmsSystemService.Put_CostGroups_Insert', [GetJsonFromDataSet(wdsCostDetails)],@OnSuccess, @OnError);


        end;
    2 : begin
          //Console.log(GetJsonFromDataSet(wdsAutomail));
          wcCostingDetails.RawInvoke('IstfmsSystemService.Put_AutoEmail_Edit', [GetJsonFromDataSet(wdsCostDetails)],@OnSuccess, @OnError);          /////////
        end;
    end;
end;

procedure TFrmCostGroupsSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel5 := TPanel.Create(Self);
  wsbtnPost := TSpeedButton.Create(Self);
  wsbtnClose := TSpeedButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  dbedtCostingGroup := TDBEdit.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  dblFleetTypes := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox2 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox3 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox4 := TDBLookupComboBox.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  TMSFNCGrid1 := TTMSFNCGrid.Create(Self);
  dbaCostDetails := TTMSFNCGridDatabaseAdapter.Create(Self);
  wpBottom := TPanel.Create(Self);
  lPageCountMax := TLabel.Create(Self);
  btnPageLeft := TSpeedButton.Create(Self);
  btnPageRight := TSpeedButton.Create(Self);
  ePageCount := TEdit.Create(Self);
  eMaxPageCount := TEdit.Create(Self);
  wdsCostGroups := TXDataWebDataSet.Create(Self);
  wdsCostGroupsCode := TIntegerField.Create(Self);
  wdsCostGroupsSuspended := TBooleanField.Create(Self);
  wdsCostGroupsDescription := TStringField.Create(Self);
  dsCostGroups := TDataSource.Create(Self);
  wdsCostDetails := TXDataWebDataSet.Create(Self);
  wdsCostDetailsCostGroupMo := TIntegerField.Create(Self);
  wdsCostDetailsFleetType := TIntegerField.Create(Self);
  wdsCostDetailsValueType := TIntegerField.Create(Self);
  wdsCostDetailsSystemType := TIntegerField.Create(Self);
  wdsCostDetailsGLCode := TStringField.Create(Self);
  wdsCDMaster := TXDataWebDataSet.Create(Self);
  dsCDMaster := TDataSource.Create(Self);
  dsCostDetails := TDataSource.Create(Self);
  wdsFleetType := TXDataWebDataSet.Create(Self);
  wdsFleetTypeDescription := TStringField.Create(Self);
  wdsFleetTypeAutoNo := TIntegerField.Create(Self);
  dsFleetTypes := TDataSource.Create(Self);
  wdsValueTypes := TXDataWebDataSet.Create(Self);
  wdsValueTypesAutoNo := TIntegerField.Create(Self);
  wdsValueTypesDescription := TStringField.Create(Self);
  dsValueTypes := TDataSource.Create(Self);
  wdsSystemTypes := TXDataWebDataSet.Create(Self);
  wdsSystemTypesDescription := TStringField.Create(Self);
  wdsSystemTypesSystemNO := TIntegerField.Create(Self);
  dsSystemTypes := TDataSource.Create(Self);
  wdsGLSystemAccounts := TXDataWebDataSet.Create(Self);
  wdsGLSystemAccountsGLCode := TIntegerField.Create(Self);
  wdsGLSystemAccountsGLDescription := TStringField.Create(Self);
  dsGLAccounts := TDataSource.Create(Self);
  wcCostingDetails := TXDataWebClient.Create(Self);
  wcFleetTypes := TXDataWebClient.Create(Self);
  wcValueTypes := TXDataWebClient.Create(Self);
  wcSystemtypes := TXDataWebClient.Create(Self);
  wcGLAcounts := TXDataWebClient.Create(Self);
  wcCostGroups := TXDataWebClient.Create(Self);
  wcPageCount := TXDataWebClient.Create(Self);

  WebPanel5.BeforeLoadDFMValues;
  wsbtnPost.BeforeLoadDFMValues;
  wsbtnClose.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  dbedtCostingGroup.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  dblFleetTypes.BeforeLoadDFMValues;
  WebDBLookupComboBox2.BeforeLoadDFMValues;
  WebDBLookupComboBox3.BeforeLoadDFMValues;
  WebDBLookupComboBox4.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  TMSFNCGrid1.BeforeLoadDFMValues;
  dbaCostDetails.BeforeLoadDFMValues;
  wpBottom.BeforeLoadDFMValues;
  lPageCountMax.BeforeLoadDFMValues;
  btnPageLeft.BeforeLoadDFMValues;
  btnPageRight.BeforeLoadDFMValues;
  ePageCount.BeforeLoadDFMValues;
  eMaxPageCount.BeforeLoadDFMValues;
  wdsCostGroups.BeforeLoadDFMValues;
  wdsCostGroupsCode.BeforeLoadDFMValues;
  wdsCostGroupsSuspended.BeforeLoadDFMValues;
  wdsCostGroupsDescription.BeforeLoadDFMValues;
  dsCostGroups.BeforeLoadDFMValues;
  wdsCostDetails.BeforeLoadDFMValues;
  wdsCostDetailsCostGroupMo.BeforeLoadDFMValues;
  wdsCostDetailsFleetType.BeforeLoadDFMValues;
  wdsCostDetailsValueType.BeforeLoadDFMValues;
  wdsCostDetailsSystemType.BeforeLoadDFMValues;
  wdsCostDetailsGLCode.BeforeLoadDFMValues;
  wdsCDMaster.BeforeLoadDFMValues;
  dsCDMaster.BeforeLoadDFMValues;
  dsCostDetails.BeforeLoadDFMValues;
  wdsFleetType.BeforeLoadDFMValues;
  wdsFleetTypeDescription.BeforeLoadDFMValues;
  wdsFleetTypeAutoNo.BeforeLoadDFMValues;
  dsFleetTypes.BeforeLoadDFMValues;
  wdsValueTypes.BeforeLoadDFMValues;
  wdsValueTypesAutoNo.BeforeLoadDFMValues;
  wdsValueTypesDescription.BeforeLoadDFMValues;
  dsValueTypes.BeforeLoadDFMValues;
  wdsSystemTypes.BeforeLoadDFMValues;
  wdsSystemTypesDescription.BeforeLoadDFMValues;
  wdsSystemTypesSystemNO.BeforeLoadDFMValues;
  dsSystemTypes.BeforeLoadDFMValues;
  wdsGLSystemAccounts.BeforeLoadDFMValues;
  wdsGLSystemAccountsGLCode.BeforeLoadDFMValues;
  wdsGLSystemAccountsGLDescription.BeforeLoadDFMValues;
  dsGLAccounts.BeforeLoadDFMValues;
  wcCostingDetails.BeforeLoadDFMValues;
  wcFleetTypes.BeforeLoadDFMValues;
  wcValueTypes.BeforeLoadDFMValues;
  wcSystemtypes.BeforeLoadDFMValues;
  wcGLAcounts.BeforeLoadDFMValues;
  wcCostGroups.BeforeLoadDFMValues;
  wcPageCount.BeforeLoadDFMValues;
  try
    Name := 'FrmCostGroupsSetup';
    Width := 1001;
    Height := 634;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -12;
    Font.Name := '@Malgun Gothic';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel5.SetParentComponent(Self);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 0;
    WebPanel5.Top := 60;
    WebPanel5.Width := 1001;
    WebPanel5.Height := 60;
    WebPanel5.Align := alTop;
    WebPanel5.BorderStyle := bsNone;
    WebPanel5.ChildOrder := 2;
    WebPanel5.Color := clSilver;
    WebPanel5.TabOrder := 0;
    wsbtnPost.SetParentComponent(WebPanel5);
    wsbtnPost.Name := 'wsbtnPost';
    wsbtnPost.Left := 216;
    wsbtnPost.Top := 13;
    wsbtnPost.Width := 193;
    wsbtnPost.Height := 41;
    wsbtnPost.Caption := 'Post';
    wsbtnPost.Color := clNone;
    wsbtnPost.HeightPercent := 100.000000000000000000;
    wsbtnPost.TabOrder := 0;
    wsbtnPost.WidthPercent := 100.000000000000000000;
    SetEvent(wsbtnPost, Self, 'OnClick', 'wsbtnPostClick');
    wsbtnClose.SetParentComponent(WebPanel5);
    wsbtnClose.Name := 'wsbtnClose';
    wsbtnClose.Left := 596;
    wsbtnClose.Top := 16;
    wsbtnClose.Width := 185;
    wsbtnClose.Height := 38;
    wsbtnClose.Caption := 'Close';
    wsbtnClose.Color := clNone;
    wsbtnClose.HeightPercent := 100.000000000000000000;
    wsbtnClose.TabOrder := 1;
    wsbtnClose.WidthPercent := 100.000000000000000000;
    SetEvent(wsbtnClose, Self, 'OnClick', 'wsbtnCloseClick');
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 180;
    WebPanel4.Width := 1001;
    WebPanel4.Height := 60;
    WebPanel4.Align := alTop;
    WebPanel4.ChildOrder := 5;
    WebPanel4.TabOrder := 1;
    WebLabel6.SetParentComponent(WebPanel4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 24;
    WebLabel6.Top := 4;
    WebLabel6.Width := 81;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Costing Group:';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    dbedtCostingGroup.SetParentComponent(WebPanel4);
    dbedtCostingGroup.Name := 'dbedtCostingGroup';
    dbedtCostingGroup.Left := 24;
    dbedtCostingGroup.Top := 25;
    dbedtCostingGroup.Width := 233;
    dbedtCostingGroup.Height := 22;
    dbedtCostingGroup.ChildOrder := 4;
    dbedtCostingGroup.Color := clWhite;
    dbedtCostingGroup.HeightPercent := 100.000000000000000000;
    dbedtCostingGroup.WidthPercent := 100.000000000000000000;
    dbedtCostingGroup.DataField := 'Descripiton';
    dbedtCostingGroup.DataSource := dsCostGroups;
    WebDBCheckBox1.SetParentComponent(WebPanel4);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 280;
    WebDBCheckBox1.Top := 24;
    WebDBCheckBox1.Width := 113;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := 'Suspeneded';
    WebDBCheckBox1.ChildOrder := 2;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.DataField := 'Suspended';
    WebDBCheckBox1.DataSource := dsCostGroups;
    WebDBCheckBox1.ValueChecked := 'True';
    WebDBCheckBox1.ValueUnChecked := 'False';
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 120;
    WebPanel3.Width := 1001;
    WebPanel3.Height := 60;
    WebPanel3.Align := alTop;
    WebPanel3.BorderStyle := bsNone;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(WebPanel3);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 332;
    WebSpeedButton1.Top := 11;
    WebSpeedButton1.Width := 45;
    WebSpeedButton1.Height := 43;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel3);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 383;
    WebSpeedButton2.Top := 11;
    WebSpeedButton2.Width := 45;
    WebSpeedButton2.Height := 43;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel3);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 434;
    WebSpeedButton3.Top := 11;
    WebSpeedButton3.Width := 45;
    WebSpeedButton3.Height := 43;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel3);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 485;
    WebSpeedButton4.Top := 11;
    WebSpeedButton4.Width := 45;
    WebSpeedButton4.Height := 43;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(WebPanel3);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 536;
    WebSpeedButton5.Top := 11;
    WebSpeedButton5.Width := 45;
    WebSpeedButton5.Height := 43;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 587;
    WebSpeedButton6.Top := 11;
    WebSpeedButton6.Width := 45;
    WebSpeedButton6.Height := 43;
    WebSpeedButton6.Caption := '^';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 5;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    WebSpeedButton7.SetParentComponent(WebPanel3);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 638;
    WebSpeedButton7.Top := 11;
    WebSpeedButton7.Width := 45;
    WebSpeedButton7.Height := 43;
    WebSpeedButton7.Caption := '-';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 6;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebPanel6.SetParentComponent(Self);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 543;
    WebPanel6.Top := 240;
    WebPanel6.Width := 458;
    WebPanel6.Height := 353;
    WebPanel6.Align := alRight;
    WebPanel6.ChildOrder := 10;
    WebPanel6.TabOrder := 3;
    WebLabel2.SetParentComponent(WebPanel6);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 123;
    WebLabel2.Top := 6;
    WebLabel2.Width := 55;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Fleet type:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel6);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 123;
    WebLabel3.Top := 77;
    WebLabel3.Width := 62;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Value Type:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel6);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 123;
    WebLabel4.Top := 150;
    WebLabel4.Width := 71;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'System Type:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel6);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 123;
    WebLabel5.Top := 228;
    WebLabel5.Width := 115;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'General Ledger Code:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    dblFleetTypes.SetParentComponent(WebPanel6);
    dblFleetTypes.Name := 'dblFleetTypes';
    dblFleetTypes.Left := 123;
    dblFleetTypes.Top := 32;
    dblFleetTypes.Width := 206;
    dblFleetTypes.Height := 22;
    dblFleetTypes.Color := clWhite;
    dblFleetTypes.HeightPercent := 100.000000000000000000;
    dblFleetTypes.WidthPercent := 100.000000000000000000;
    dblFleetTypes.DataField := 'FleetType';
    dblFleetTypes.DataSource := dsCostDetails;
    dblFleetTypes.KeyField := 'AutoNo';
    dblFleetTypes.ListField := 'Description';
    dblFleetTypes.ListSource := dsFleetTypes;
    WebDBLookupComboBox2.SetParentComponent(WebPanel6);
    WebDBLookupComboBox2.Name := 'WebDBLookupComboBox2';
    WebDBLookupComboBox2.Left := 123;
    WebDBLookupComboBox2.Top := 176;
    WebDBLookupComboBox2.Width := 206;
    WebDBLookupComboBox2.Height := 22;
    WebDBLookupComboBox2.Color := clWhite;
    WebDBLookupComboBox2.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox2.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox2.DataField := 'SystemType';
    WebDBLookupComboBox2.DataSource := dsCostDetails;
    WebDBLookupComboBox2.KeyField := 'SystemNO';
    WebDBLookupComboBox2.ListField := 'Description';
    WebDBLookupComboBox2.ListSource := dsSystemTypes;
    WebDBLookupComboBox3.SetParentComponent(WebPanel6);
    WebDBLookupComboBox3.Name := 'WebDBLookupComboBox3';
    WebDBLookupComboBox3.Left := 131;
    WebDBLookupComboBox3.Top := 98;
    WebDBLookupComboBox3.Width := 206;
    WebDBLookupComboBox3.Height := 22;
    WebDBLookupComboBox3.Color := clWhite;
    WebDBLookupComboBox3.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox3.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox3.DataField := 'ValueType';
    WebDBLookupComboBox3.DataSource := dsCostDetails;
    WebDBLookupComboBox3.KeyField := 'AutoNo';
    WebDBLookupComboBox3.ListField := 'Description';
    WebDBLookupComboBox3.ListSource := dsValueTypes;
    WebDBLookupComboBox4.SetParentComponent(WebPanel6);
    WebDBLookupComboBox4.Name := 'WebDBLookupComboBox4';
    WebDBLookupComboBox4.Left := 123;
    WebDBLookupComboBox4.Top := 254;
    WebDBLookupComboBox4.Width := 318;
    WebDBLookupComboBox4.Height := 22;
    WebDBLookupComboBox4.Color := clWhite;
    WebDBLookupComboBox4.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox4.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox4.DataField := 'GLCode';
    WebDBLookupComboBox4.DataSource := dsCostDetails;
    WebDBLookupComboBox4.KeyField := 'GLCode';
    WebDBLookupComboBox4.ListField := 'GLDescription';
    WebDBLookupComboBox4.ListSource := dsGLAccounts;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1001;
    WebPanel1.Height := 60;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 5;
    WebPanel1.TabOrder := 4;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 1001;
    WebLabel1.Height := 25;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Costing Groups';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -18;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    TMSFNCGrid1.SetParentComponent(Self);
    TMSFNCGrid1.Name := 'TMSFNCGrid1';
    TMSFNCGrid1.Left := 0;
    TMSFNCGrid1.Top := 240;
    TMSFNCGrid1.Width := 632;
    TMSFNCGrid1.Height := 353;
    TMSFNCGrid1.Align := alLeft;
    TMSFNCGrid1.ParentDoubleBuffered := False;
    TMSFNCGrid1.DoubleBuffered := True;
    TMSFNCGrid1.TabOrder := 5;
    TMSFNCGrid1.DefaultRowHeight := 40.000000000000000000;
    TMSFNCGrid1.FixedColumns := 0;
    TMSFNCGrid1.ColumnCount := 6;
    TMSFNCGrid1.RowCount := 1;
    TMSFNCGrid1.Options.Bands.Enabled := True;
    TMSFNCGrid1.Options.Editing.CalcFormat := '%g';
    TMSFNCGrid1.Options.Grouping.CalcFormat := '%g';
    TMSFNCGrid1.Options.Grouping.GroupCountFormat := '(%d)';
    TMSFNCGrid1.Options.IO.XMLEncoding := 'ISO-8859-1';
    TMSFNCGrid1.Options.Mouse.ClickMargin := 0;
    TMSFNCGrid1.Options.Mouse.ColumnSizeMargin := 6;
    TMSFNCGrid1.Options.Mouse.RowSizeMargin := 6;
    TMSFNCGrid1.Adapter := dbaCostDetails;
    TMSFNCGrid1.Columns.Clear;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 250.000000000000000000;
    end;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 90.000000000000000000;
    end;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 68.000000000000000000;
    end;
    TMSFNCGrid1.DefaultFont.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.DefaultFont.Color := clWindowText;
    TMSFNCGrid1.DefaultFont.Height := -11;
    TMSFNCGrid1.DefaultFont.Name := 'Segoe UI';
    TMSFNCGrid1.DefaultFont.Style := [];
    TMSFNCGrid1.TopRow := 1;
    TMSFNCGrid1.Appearance.FixedLayout.Fill.Color := 16380654;
    TMSFNCGrid1.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.FixedLayout.Font.Color := 4539717;
    TMSFNCGrid1.Appearance.FixedLayout.Font.Height := -13;
    TMSFNCGrid1.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.FixedLayout.Font.Style := [fsBold];
    TMSFNCGrid1.Appearance.NormalLayout.Fill.Color := 16578806;
    TMSFNCGrid1.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.NormalLayout.Font.Color := 8026746;
    TMSFNCGrid1.Appearance.NormalLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.NormalLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.GroupLayout.Fill.Color := 12817262;
    TMSFNCGrid1.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.GroupLayout.Font.Color := clBlack;
    TMSFNCGrid1.Appearance.GroupLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.GroupLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.SummaryLayout.Fill.Color := 14009785;
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Color := clBlack;
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.SelectedLayout.Fill.Color := 16441019;
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Color := 4539717;
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.FocusedLayout.Fill.Color := 16039284;
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Color := 4539717;
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.BandLayout.Fill.Color := 16711679;
    TMSFNCGrid1.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.BandLayout.Font.Color := 8026746;
    TMSFNCGrid1.Appearance.BandLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.BandLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.ProgressLayout.Format := '%.0f%%';
    TMSFNCGrid1.LeftCol := 1;
    TMSFNCGrid1.ScrollMode := scmItemScrolling;
    TMSFNCGrid1.DesignTimeSampleData := True;
    dbaCostDetails.SetParentComponent(TMSFNCGrid1);
    dbaCostDetails.Name := 'dbaCostDetails';
    dbaCostDetails.Left := 79;
    dbaCostDetails.Top := 16;
    dbaCostDetails.Width := 26;
    dbaCostDetails.Height := 26;
    dbaCostDetails.Visible := True;
    dbaCostDetails.Active := True;
    dbaCostDetails.Grid := TMSFNCGrid1;
    dbaCostDetails.DataSource := dsCostDetails;
    dbaCostDetails.Columns.Clear;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'CostGroupMo';
      Header := 'CostGroupMo';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'FleetType';
      Header := 'Fleet Type';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'ValueType';
      Header := 'Value Types';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'SystemType';
      Header := 'System Types';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      FieldName := 'GLCode';
      Header := ' GL Code';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostDetails.Columns.Add do
    begin
      Header := 'Delete';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    wpBottom.SetParentComponent(Self);
    wpBottom.Name := 'wpBottom';
    wpBottom.Left := 0;
    wpBottom.Top := 593;
    wpBottom.Width := 1001;
    wpBottom.Height := 41;
    wpBottom.Align := alBottom;
    wpBottom.BorderStyle := bsNone;
    wpBottom.ChildOrder := 2;
    wpBottom.Color := clSilver;
    wpBottom.TabOrder := 6;
    lPageCountMax.SetParentComponent(wpBottom);
    lPageCountMax.Name := 'lPageCountMax';
    lPageCountMax.Left := 74;
    lPageCountMax.Top := 14;
    lPageCountMax.Width := 15;
    lPageCountMax.Height := 15;
    lPageCountMax.Caption := 'OF';
    lPageCountMax.HeightPercent := 100.000000000000000000;
    lPageCountMax.WidthPercent := 100.000000000000000000;
    btnPageLeft.SetParentComponent(wpBottom);
    btnPageLeft.Name := 'btnPageLeft';
    btnPageLeft.Left := 14;
    btnPageLeft.Top := 6;
    btnPageLeft.Width := 26;
    btnPageLeft.Height := 26;
    btnPageLeft.Color := clNone;
    btnPageLeft.GlyphURL := 'images/buttons/prior.svg';
    btnPageLeft.GlyphSize := 20;
    btnPageLeft.HeightPercent := 100.000000000000000000;
    btnPageLeft.TabOrder := 0;
    btnPageLeft.WidthPercent := 100.000000000000000000;
    SetEvent(btnPageLeft, Self, 'OnClick', 'btnPageLeftClick');
    btnPageRight.SetParentComponent(wpBottom);
    btnPageRight.Name := 'btnPageRight';
    btnPageRight.Left := 120;
    btnPageRight.Top := 8;
    btnPageRight.Width := 26;
    btnPageRight.Height := 26;
    btnPageRight.Color := clNone;
    btnPageRight.GlyphURL := 'images/buttons/next.svg';
    btnPageRight.GlyphSize := 20;
    btnPageRight.HeightPercent := 100.000000000000000000;
    btnPageRight.TabOrder := 1;
    btnPageRight.WidthPercent := 100.000000000000000000;
    SetEvent(btnPageRight, Self, 'OnClick', 'btnPageRightClick');
    ePageCount.SetParentComponent(wpBottom);
    ePageCount.Name := 'ePageCount';
    ePageCount.Left := 46;
    ePageCount.Top := 9;
    ePageCount.Width := 25;
    ePageCount.Height := 24;
    ePageCount.Alignment := taCenter;
    ePageCount.ChildOrder := 2;
    ePageCount.EditType := weNumeric;
    ePageCount.HeightPercent := 100.000000000000000000;
    ePageCount.WidthPercent := 100.000000000000000000;
    SetEvent(ePageCount, Self, 'OnExit', 'ePageCountExit');
    eMaxPageCount.SetParentComponent(wpBottom);
    eMaxPageCount.Name := 'eMaxPageCount';
    eMaxPageCount.Left := 92;
    eMaxPageCount.Top := 9;
    eMaxPageCount.Width := 25;
    eMaxPageCount.Height := 24;
    eMaxPageCount.Alignment := taCenter;
    eMaxPageCount.ChildOrder := 2;
    eMaxPageCount.EditType := weNumeric;
    eMaxPageCount.HeightPercent := 100.000000000000000000;
    eMaxPageCount.ReadOnly := True;
    eMaxPageCount.WidthPercent := 100.000000000000000000;
    wdsCostGroups.SetParentComponent(Self);
    wdsCostGroups.Name := 'wdsCostGroups';
    wdsCostGroups.EntitySetName := 'costgroups';
    wdsCostGroups.Connection := dmData.dbConnect;
    wdsCostGroups.Left := 72;
    wdsCostGroups.Top := 73;
    wdsCostGroupsCode.SetParentComponent(wdsCostGroups);
    wdsCostGroupsCode.Name := 'wdsCostGroupsCode';
    wdsCostGroupsCode.FieldName := 'Code';
    wdsCostGroupsSuspended.SetParentComponent(wdsCostGroups);
    wdsCostGroupsSuspended.Name := 'wdsCostGroupsSuspended';
    wdsCostGroupsSuspended.FieldName := 'Suspended';
    wdsCostGroupsDescription.SetParentComponent(wdsCostGroups);
    wdsCostGroupsDescription.Name := 'wdsCostGroupsDescription';
    wdsCostGroupsDescription.FieldKind := fkCalculated;
    wdsCostGroupsDescription.FieldName := 'Description';
    wdsCostGroupsDescription.Calculated := True;
    dsCostGroups.SetParentComponent(Self);
    dsCostGroups.Name := 'dsCostGroups';
    dsCostGroups.DataSet := wdsCostGroups;
    dsCostGroups.Left := 160;
    dsCostGroups.Top := 73;
    wdsCostDetails.SetParentComponent(Self);
    wdsCostDetails.Name := 'wdsCostDetails';
    wdsCostDetails.Connection := dmData.dbConnect;
    wdsCostDetails.Left := 176;
    wdsCostDetails.Top := 255;
    wdsCostDetailsCostGroupMo.SetParentComponent(wdsCostDetails);
    wdsCostDetailsCostGroupMo.Name := 'wdsCostDetailsCostGroupMo';
    wdsCostDetailsCostGroupMo.FieldName := 'CostGroupMo';
    wdsCostDetailsFleetType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsFleetType.Name := 'wdsCostDetailsFleetType';
    wdsCostDetailsFleetType.FieldName := 'FleetType';
    wdsCostDetailsValueType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsValueType.Name := 'wdsCostDetailsValueType';
    wdsCostDetailsValueType.FieldName := 'ValueType';
    wdsCostDetailsSystemType.SetParentComponent(wdsCostDetails);
    wdsCostDetailsSystemType.Name := 'wdsCostDetailsSystemType';
    wdsCostDetailsSystemType.FieldName := 'SystemType';
    wdsCostDetailsGLCode.SetParentComponent(wdsCostDetails);
    wdsCostDetailsGLCode.Name := 'wdsCostDetailsGLCode';
    wdsCostDetailsGLCode.FieldName := 'GLCode';
    wdsCDMaster.SetParentComponent(Self);
    wdsCDMaster.Name := 'wdsCDMaster';
    wdsCDMaster.Connection := dmData.dbConnect;
    wdsCDMaster.Left := 672;
    wdsCDMaster.Top := 575;
    dsCDMaster.SetParentComponent(Self);
    dsCDMaster.Name := 'dsCDMaster';
    dsCDMaster.DataSet := wdsCDMaster;
    dsCDMaster.Left := 760;
    dsCDMaster.Top := 575;
    dsCostDetails.SetParentComponent(Self);
    dsCostDetails.Name := 'dsCostDetails';
    dsCostDetails.AutoEdit := False;
    dsCostDetails.DataSet := wdsCostDetails;
    dsCostDetails.Left := 288;
    dsCostDetails.Top := 256;
    wdsFleetType.SetParentComponent(Self);
    wdsFleetType.Name := 'wdsFleetType';
    wdsFleetType.Connection := dmData.dbConnect;
    wdsFleetType.Left := 536;
    wdsFleetType.Top := 261;
    wdsFleetTypeDescription.SetParentComponent(wdsFleetType);
    wdsFleetTypeDescription.Name := 'wdsFleetTypeDescription';
    wdsFleetTypeDescription.FieldName := 'Description';
    wdsFleetTypeAutoNo.SetParentComponent(wdsFleetType);
    wdsFleetTypeAutoNo.Name := 'wdsFleetTypeAutoNo';
    wdsFleetTypeAutoNo.FieldName := 'AutoNo';
    dsFleetTypes.SetParentComponent(Self);
    dsFleetTypes.Name := 'dsFleetTypes';
    dsFleetTypes.AutoEdit := False;
    dsFleetTypes.DataSet := wdsFleetType;
    dsFleetTypes.Left := 616;
    dsFleetTypes.Top := 261;
    wdsValueTypes.SetParentComponent(Self);
    wdsValueTypes.Name := 'wdsValueTypes';
    wdsValueTypes.Connection := dmData.dbConnect;
    wdsValueTypes.Left := 552;
    wdsValueTypes.Top := 333;
    wdsValueTypesAutoNo.SetParentComponent(wdsValueTypes);
    wdsValueTypesAutoNo.Name := 'wdsValueTypesAutoNo';
    wdsValueTypesAutoNo.FieldName := 'AutoNo';
    wdsValueTypesDescription.SetParentComponent(wdsValueTypes);
    wdsValueTypesDescription.Name := 'wdsValueTypesDescription';
    wdsValueTypesDescription.FieldName := 'Description';
    dsValueTypes.SetParentComponent(Self);
    dsValueTypes.Name := 'dsValueTypes';
    dsValueTypes.DataSet := wdsValueTypes;
    dsValueTypes.Left := 608;
    dsValueTypes.Top := 333;
    wdsSystemTypes.SetParentComponent(Self);
    wdsSystemTypes.Name := 'wdsSystemTypes';
    wdsSystemTypes.Connection := dmData.dbConnect;
    wdsSystemTypes.Left := 552;
    wdsSystemTypes.Top := 405;
    wdsSystemTypesDescription.SetParentComponent(wdsSystemTypes);
    wdsSystemTypesDescription.Name := 'wdsSystemTypesDescription';
    wdsSystemTypesDescription.FieldName := 'Description';
    wdsSystemTypesSystemNO.SetParentComponent(wdsSystemTypes);
    wdsSystemTypesSystemNO.Name := 'wdsSystemTypesSystemNO';
    wdsSystemTypesSystemNO.FieldKind := fkCalculated;
    wdsSystemTypesSystemNO.FieldName := 'SystemNO';
    wdsSystemTypesSystemNO.Calculated := True;
    dsSystemTypes.SetParentComponent(Self);
    dsSystemTypes.Name := 'dsSystemTypes';
    dsSystemTypes.DataSet := wdsSystemTypes;
    dsSystemTypes.Left := 616;
    dsSystemTypes.Top := 405;
    wdsGLSystemAccounts.SetParentComponent(Self);
    wdsGLSystemAccounts.Name := 'wdsGLSystemAccounts';
    wdsGLSystemAccounts.Connection := dmData.dbConnect;
    wdsGLSystemAccounts.Left := 552;
    wdsGLSystemAccounts.Top := 485;
    wdsGLSystemAccountsGLCode.SetParentComponent(wdsGLSystemAccounts);
    wdsGLSystemAccountsGLCode.Name := 'wdsGLSystemAccountsGLCode';
    wdsGLSystemAccountsGLCode.FieldName := 'GLCode';
    wdsGLSystemAccountsGLDescription.SetParentComponent(wdsGLSystemAccounts);
    wdsGLSystemAccountsGLDescription.Name := 'wdsGLSystemAccountsGLDescription';
    wdsGLSystemAccountsGLDescription.FieldName := 'GLDescription';
    dsGLAccounts.SetParentComponent(Self);
    dsGLAccounts.Name := 'dsGLAccounts';
    dsGLAccounts.DataSet := wdsGLSystemAccounts;
    dsGLAccounts.Left := 616;
    dsGLAccounts.Top := 485;
    wcCostingDetails.SetParentComponent(Self);
    wcCostingDetails.Name := 'wcCostingDetails';
    wcCostingDetails.Connection := dmData.dbConnect;
    wcCostingDetails.Left := 80;
    wcCostingDetails.Top := 320;
    wcFleetTypes.SetParentComponent(Self);
    wcFleetTypes.Name := 'wcFleetTypes';
    wcFleetTypes.Connection := dmData.dbConnect;
    wcFleetTypes.Left := 448;
    wcFleetTypes.Top := 260;
    wcValueTypes.SetParentComponent(Self);
    wcValueTypes.Name := 'wcValueTypes';
    wcValueTypes.Connection := dmData.dbConnect;
    wcValueTypes.Left := 488;
    wcValueTypes.Top := 336;
    wcSystemtypes.SetParentComponent(Self);
    wcSystemtypes.Name := 'wcSystemtypes';
    wcSystemtypes.Connection := dmData.dbConnect;
    wcSystemtypes.Left := 488;
    wcSystemtypes.Top := 408;
    wcGLAcounts.SetParentComponent(Self);
    wcGLAcounts.Name := 'wcGLAcounts';
    wcGLAcounts.Connection := dmData.dbConnect;
    wcGLAcounts.Left := 480;
    wcGLAcounts.Top := 488;
    wcCostGroups.SetParentComponent(Self);
    wcCostGroups.Name := 'wcCostGroups';
    wcCostGroups.Connection := dmData.dbConnect;
    wcCostGroups.Left := 120;
    wcCostGroups.Top := 16;
    wcPageCount.SetParentComponent(Self);
    wcPageCount.Name := 'wcPageCount';
    wcPageCount.Connection := dmData.dbConnect;
    wcPageCount.Left := 72;
    wcPageCount.Top := 416;
  finally
    WebPanel5.AfterLoadDFMValues;
    wsbtnPost.AfterLoadDFMValues;
    wsbtnClose.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    dbedtCostingGroup.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    dblFleetTypes.AfterLoadDFMValues;
    WebDBLookupComboBox2.AfterLoadDFMValues;
    WebDBLookupComboBox3.AfterLoadDFMValues;
    WebDBLookupComboBox4.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    TMSFNCGrid1.AfterLoadDFMValues;
    dbaCostDetails.AfterLoadDFMValues;
    wpBottom.AfterLoadDFMValues;
    lPageCountMax.AfterLoadDFMValues;
    btnPageLeft.AfterLoadDFMValues;
    btnPageRight.AfterLoadDFMValues;
    ePageCount.AfterLoadDFMValues;
    eMaxPageCount.AfterLoadDFMValues;
    wdsCostGroups.AfterLoadDFMValues;
    wdsCostGroupsCode.AfterLoadDFMValues;
    wdsCostGroupsSuspended.AfterLoadDFMValues;
    wdsCostGroupsDescription.AfterLoadDFMValues;
    dsCostGroups.AfterLoadDFMValues;
    wdsCostDetails.AfterLoadDFMValues;
    wdsCostDetailsCostGroupMo.AfterLoadDFMValues;
    wdsCostDetailsFleetType.AfterLoadDFMValues;
    wdsCostDetailsValueType.AfterLoadDFMValues;
    wdsCostDetailsSystemType.AfterLoadDFMValues;
    wdsCostDetailsGLCode.AfterLoadDFMValues;
    wdsCDMaster.AfterLoadDFMValues;
    dsCDMaster.AfterLoadDFMValues;
    dsCostDetails.AfterLoadDFMValues;
    wdsFleetType.AfterLoadDFMValues;
    wdsFleetTypeDescription.AfterLoadDFMValues;
    wdsFleetTypeAutoNo.AfterLoadDFMValues;
    dsFleetTypes.AfterLoadDFMValues;
    wdsValueTypes.AfterLoadDFMValues;
    wdsValueTypesAutoNo.AfterLoadDFMValues;
    wdsValueTypesDescription.AfterLoadDFMValues;
    dsValueTypes.AfterLoadDFMValues;
    wdsSystemTypes.AfterLoadDFMValues;
    wdsSystemTypesDescription.AfterLoadDFMValues;
    wdsSystemTypesSystemNO.AfterLoadDFMValues;
    dsSystemTypes.AfterLoadDFMValues;
    wdsGLSystemAccounts.AfterLoadDFMValues;
    wdsGLSystemAccountsGLCode.AfterLoadDFMValues;
    wdsGLSystemAccountsGLDescription.AfterLoadDFMValues;
    dsGLAccounts.AfterLoadDFMValues;
    wcCostingDetails.AfterLoadDFMValues;
    wcFleetTypes.AfterLoadDFMValues;
    wcValueTypes.AfterLoadDFMValues;
    wcSystemtypes.AfterLoadDFMValues;
    wcGLAcounts.AfterLoadDFMValues;
    wcCostGroups.AfterLoadDFMValues;
    wcPageCount.AfterLoadDFMValues;
  end;
end;

end.
